var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBookOpenText = function SvgBookOpenText(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.55556V20M12 7.55556C12 6.61256 11.6207 5.70819 10.9456 5.0414C10.2705 4.3746 9.35478 4 8.4 4H3.9C3.66131 4 3.43239 4.09365 3.2636 4.26035C3.09482 4.42705 3 4.65314 3 4.88889V16.4444C3 16.6802 3.09482 16.9063 3.2636 17.073C3.43239 17.2397 3.66131 17.3333 3.9 17.3333H9.3C10.0161 17.3333 10.7028 17.6143 11.2092 18.1144C11.7155 18.6145 12 19.2928 12 20M12 7.55556C12 6.61256 12.3793 5.70819 13.0544 5.0414C13.7295 4.3746 14.6452 4 15.6 4H20.1C20.3387 4 20.5676 4.09365 20.7364 4.26035C20.9052 4.42705 21 4.65314 21 4.88889V16.4444C21 16.6802 20.9052 16.9063 20.7364 17.073C20.5676 17.2397 20.3387 17.3333 20.1 17.3333H14.7C13.9839 17.3333 13.2972 17.6143 12.7908 18.1144C12.2845 18.6145 12 19.2928 12 20M15.6 12H17.4M15.6 8.44444H17.4M6.6 12H8.4M6.6 8.44444H8.4",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBookOpenText);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "book-open-text.8d63327120629084a5594783d7f0d553.svg";